import React, { useEffect, useState } from "react";
import "../styles/myplan.css";
import {
  exportTopPlanList,
  fetchTopPlanDetail,
  fetchTopPlanList,
} from "../api/market";
import moment from "moment";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Label,
  Spinner,
  Table,
  Modal,
  ModalHeader,
  Dropdown,
} from "reactstrap";
import DataTable from "react-data-table-component";
import Flatpickr from "react-flatpickr";
import Loader from "./Common/Loader";
import { DataSeriesTypes } from "../types";
import { errornotify } from "./Message";
import { KWHPriceChart } from "./KWHPriceChart";
import { useDispatch, useSelector } from "react-redux";
import { getKWHPrice } from "../store/actions";
import { NoResult } from "./Common/NoResult";
import { jumpTo } from "./UrlModal";
// import AiSummary from "./AiSummary";
import { selectUtility } from "../store/utility/selector";
import { RankChart } from "./Charts/RankChart";
import UsageBtnGroup from "./UsageBtnGroup";
import { selectLocation } from "../store/location/selector";
import { Tooltip, Typography } from "@mui/material";
import { selectMyProvider } from "../store/myProvider/selector";
import { useLocation, useHistory } from "react-router-dom";
import { MultiSelectFilterDropdown } from "./Common/MultiSelectFilterDropdown";
import { usePersistedPagination } from "./Hooks/usePersistedPagination";
import { useTableSortReset } from "./Hooks/useTableSortReset";
import {
  extractUniqueSources,
  extractUniqueTerms,
  matchesSourceFilter,
  matchesTermFilter,
} from "../utils/planFilters";
import {
  createNumericSortFunction,
  createStringSortFunction,
} from "../utils/planTableSort";
import {
  ActiveFilterTags,
  activeFilterTagClassName,
} from "./Common/ActiveFilterTags";

interface topPlanObj {
  base_rate: String;
  cancel_fee: String;
  created_ts: String;
  diff: any;
  efl_url: string;
  energy_charge1: any;
  plan_id: String;
  plan_name: String;
  price: String;
  provider_id: String;
  provider_name: String;
  term: string;
  utility_id: String;
  utility_name: String;
  rank: any;
  source: any;
}
interface detail {
  plan: any;
  rank: any;
}

const startDate = moment().subtract(1, "months").format("YYYY-MM-DD");
const today = moment().format("YYYY-MM-DD");

const LoginTopPlan = () => {
  const myProvider = useSelector(selectMyProvider);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const [filterValue, setFilterValue] = useState<{
    created_ts: string;
    price: number;
    provider_id: string;
    plan_type?: "" | number;
  }>({
    created_ts: today,
    price: 500,
    provider_id: "",
    plan_type: "",
  });
  const [value, setValue] = useState<any>(today);
  const [dataPlanList, setDataPlanList] = useState<Array<topPlanObj>>([]);
  const [checked, setChecked] = useState(false);
  const [isDownload, setIsDownload] = useState(false);
  const [selectedTerms, setSelectedTerms] = useState<string[]>([]);
  const [showMeData, setShowMeData] = useState<Array<topPlanObj>>([]);
  const [selectedSources, setSelectedSources] = useState<string[]>([]);
  const [openSource, setOpenSource] = useState(false);
  const [openPlanType, setOpenPlanType] = useState(false);
  const [dataString, setDataString] = useState("");
  const {
    tablePage,
    setTablePage,
    rowsPerPage,
    handleRowsPerPageChange,
    resetPage,
    paginationRowsPerPageOptions,
  } = usePersistedPagination("loginTopPlan_rowsPerPage", 10);
  const { sortResetKey, resetTableSort } = useTableSortReset();
  const currentLocation = useSelector(selectLocation);
  const currentUtility = useSelector(selectUtility);
  const [openProvider, setOpenProvider] = useState(false);
  const [selectedProviderId, setSelectedProviderId] = useState<string>("");
  const location = useLocation();
  const history = useHistory();
  const getPlanList = async (
    created_ts: string,
    price: number,
    plan_type: "" | number
  ) => {
    setIsLoading(true);
    setChecked(false);
    setDataPlanList([]);
    resetPage();
    const res = await fetchTopPlanList({
      utility_id: currentUtility.utility_id,
      created_ts,
      price,
      plan_type,
    });

    if (res.status !== 1 || res.response.length === 0) {
      // errornotify(res.message || "Error");
      setIsLoading(false);
      return;
    }
    let efl = res.response[0].efl_url;
    let iRank = 1;
    setDataPlanList(
      res.response.map((item: any) => {
        if (item.efl_url === efl) {
          return {
            ...item,
            rank: iRank,
          };
        } else {
          efl = item.efl_url;
          iRank += 1;
          return {
            ...item,
            rank: iRank,
          };
        }
      })
    );
    setIsLoading(false);
  };
  useEffect(() => {
    if (!currentUtility) return;
    getPlanList(
      filterValue.created_ts,
      filterValue.price,
      filterValue.plan_type || ""
    );
  }, [filterValue.created_ts, filterValue.price, filterValue.plan_type, currentUtility]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const created_ts = searchParams.get("created_ts");
    const usage = searchParams.get("usage");
    const term = searchParams.get("term");
    const provider_id = searchParams.get("provider_id");
    const source = searchParams.get("source");
    const plan_type = searchParams.get("plan_type");

    if (created_ts || usage || term || provider_id || source || plan_type) {
      setFilterValue((prev) => ({
        ...prev,
        created_ts: created_ts || prev.created_ts,
        price: usage ? +usage : prev.price,
        provider_id: provider_id || "",
        plan_type: plan_type ? +plan_type : "",
      }));
      if (created_ts) setValue(created_ts);
      if (term) setSelectedTerms([String(term).trim()]);
      if (provider_id) setSelectedProviderId(provider_id);
      if (source) setSelectedSources([source.toUpperCase()]);
    }
  }, [location.search]);

  const changeDate = (val: any) => {
    setFilterValue({
      ...filterValue,
      created_ts: moment(val).format("YYYY-MM-DD"),
    });
    resetTableSort();
  };

  const changeUsage = (val: string) => {
    setFilterValue({
      ...filterValue,
      price: +val,
    });
    resetTableSort();
  };
  const showMeOnly = (flag: boolean) => {
    setChecked(flag);
    resetPage();
    resetTableSort();
    let myData: any = [];
    dataPlanList.forEach((item) => {
      if (item?.provider_id === myProvider?.provider_id) {
        myData.push(item);
      }
    });

    setShowMeData(myData);
  };

  const [open, setOpen] = React.useState(false);
  const [isShow, setIsShow] = useState(false);
  const [planDetail, setPlanDetail] = useState<detail>({
    plan: {},
    rank: 0,
  });

  const [detailData, setdetailData] = useState<DataSeriesTypes[]>([]);
  const [openSelect, setOpenSelect] = useState(false);
  const [hasRankTrend, setHasRankTrend] = useState(true);

  const handleOpen = async (
    plan_id: any,
    price: any,
    created_ts: any,
    rank: any
  ) => {
    setOpen(true);
    setIsShow(true);
    dispatch(getKWHPrice(true));
    const res = await fetchTopPlanDetail(
      plan_id,
      price,
      created_ts,
      `${startDate}&${today}`
    );
    let detailDataArr: any[] = [];
    setHasRankTrend(true);
    if (res.status !== 1 || res.response.rank_trend.length === 0) {
      detailDataArr = [];
      setHasRankTrend(false);
      errornotify(res.message || "No Trend Data");
      setIsShow(false);
      return;
    }

    res.response.rank_trend.map((item: any) => {
      if (item.rank !== 0)
        return detailDataArr.push({ x: item.date, y: item.rank });
      else return detailDataArr.push({ x: item.date, y: null });
    });
    setdetailData([
      { id: "Rank", data: detailDataArr.filter((i: any) => i.y) },
    ]);
    setPlanDetail({
      plan: res.response.plan,
      rank: rank,
    });
    setDataString(`
            ##Plan Rank Trend
            ${JSON.stringify({
              plan: res.response.plan,
              rank: rank,
            })}
        `);
    setIsShow(false);
  };
  const handleClose = () => {
    setOpen(false);
    setDataString("");
    dispatch(getKWHPrice(false));
  };

  const changeProvider = (provider_id: string) => {
    setSelectedProviderId(provider_id);
    resetTableSort();
  };

  const changePlanType = (plan_type: "" | number) => {
    setFilterValue((prev) => ({ ...prev, plan_type }));
    resetTableSort();
  };

  const handleTermsChange = (terms: string[]) => {
    setSelectedTerms(terms);
    resetTableSort();
  };

  const handleSourcesChange = (sources: string[]) => {
    setSelectedSources(sources);
    resetTableSort();
  };

  const handleJumpToPlanInsight = () => {
    if (!planDetail.plan) return;
    const params = new URLSearchParams();
    if (filterValue.created_ts) {
      params.set("created_ts", filterValue.created_ts);
    }
    if (filterValue.price) {
      params.set("usage", String(filterValue.price));
    }
    if (planDetail.plan.contract_term) {
      params.set("term", String(planDetail.plan.contract_term));
    }
    if (planDetail.plan.provider_id) {
      params.set("provider_id", String(planDetail.plan.provider_id));
    }
    if (planDetail.plan.source) {
      params.set("source", String(planDetail.plan.source));
    }
    if (
      filterValue.plan_type !== undefined &&
      filterValue.plan_type !== null &&
      filterValue.plan_type !== ""
    ) {
      params.set("plan_type", String(filterValue.plan_type));
    } else if (
      planDetail.plan.plan_type !== undefined &&
      planDetail.plan.plan_type !== null &&
      planDetail.plan.plan_type !== ""
    ) {
      params.set("plan_type", String(planDetail.plan.plan_type));
    }
    if (currentUtility?.utility_id) {
      params.set("utility_id", String(currentUtility.utility_id));
    }
    history.push(`/plan-insight?${params.toString()}`);
    setOpen(false);
    dispatch(getKWHPrice(false));
  };

  const exportList = async () => {
    setIsDownload(true);
    const res = await exportTopPlanList({
      utility_id: currentUtility.utility_id,
      ...filterValue,
    });

    const fileName = res.headers
      .get("content-disposition")
      ?.split("filename=")[1];

    const data = await res.blob();

    const url = window.URL.createObjectURL(data);
    const link = document.createElement("a");
    link.style.display = "none";
    link.href = url;
    link.setAttribute("download", fileName || `TopPlanList${value}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setIsDownload(false);
  };

  const conditionalRowStyles: any = [
    {
      when: (row: any) => row?.provider_id === myProvider?.provider_id,
      style: { backgroundImage: "linear-gradient(-90deg,#ffffff, #F3EEFE)" },
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#F2F2F2",
        paddingRight: 0,
      },
    },
  };

  const formatCreditValue = (credit: unknown) => {
    const value = Number(credit || 0);
    return `$${value.toFixed(2)}`;
  };

  const buildCreditTooltip = (planInfo: any) => {
    const tiers = [1, 2, 3]
      .map((tier) => {
        const amount = Number(planInfo?.[`credit${tier}`] || 0);
        if (!amount) {
          return "";
        }

        const start = Number(planInfo?.[`credit${tier}_kwh_start`] || 0);
        const end = Number(planInfo?.[`credit${tier}_kwh_end`] || 0);
        const endText = end ? ` and <= ${end} kWh` : "";
        return `Tier ${tier}: $${amount.toFixed(0)} rebate when usage > ${start} kWh${endText}.`;
      })
      .filter(Boolean);

    return tiers.join(" ");
  };

  const realData = checked ? showMeData : dataPlanList;
  let filterData = realData.filter((item) =>
    matchesTermFilter(item, selectedTerms, "term")
  );
  filterData = filterData.filter((item) =>
    matchesSourceFilter(item, selectedSources)
  );

  const providerOptionsFromList = Array.from(
    new Map(
      filterData.map((item: any) => [
        item.provider_id,
        { provider_id: item.provider_id, provider_name: item.provider_name || "" },
      ])
    ).values()
  );
  let filterProviders = providerOptionsFromList;

  if (selectedProviderId) {
    filterProviders = providerOptionsFromList.filter(
      (p: any) => String(p.provider_id) === String(selectedProviderId)
    );
    filterData = filterData.filter(
      (item: any) => String(item.provider_id) === String(selectedProviderId)
    );
  }
  // Plan Type is filtered by TopPlan/index API; no client-side filter here

  const filterSources = extractUniqueSources(realData);
  const filterTerms = extractUniqueTerms(realData, "term");

  const renderTopPlanTable = () => {
    const columns: any[] = [
      {
        name: <span className="font-weight-bold fs-14">Rank</span>,
        selector: (row: any) => row.rank,
        width: "90px",
        sortable: true,
        sortFunction: createNumericSortFunction("rank"),
      },
      {
        name: <span className="font-weight-bold fs-14">REP Name</span>,
        selector: (row: any) => row.provider_name,
        sortable: true,
        sortFunction: createStringSortFunction("provider_name"),
      },
      {
        name: <span className="font-weight-bold fs-14">Plan Name</span>,
        selector: (row: any) => {
          return (
            <Tooltip 
              title={row.plan_name} 
              placement="top"
              id={row.plan_id}
              arrow
            >
              <div className="plan-name-cell">
                <span className="text-truncate d-inline-block font-weight-bold fs-14">
                  {row.plan_name}
                </span>
              </div>
            </Tooltip>
          );
        },
        sortable: true,
        sortFunction: createStringSortFunction("plan_name"),
      },
      {
        name: <span className="font-weight-bold fs-14">Term</span>,
        selector: (row: any) => row.term,
        sortable: true,
        sortFunction: createNumericSortFunction("term"),
        style: {
          paddingLeft: "1.5rem",
        },
        width: "95px",
      },
      {
        name: (
          <span className="font-weight-bold fs-14">{`${filterValue.price}kWh`}</span>
        ),
        selector: (row: any) => row.base_rate,
        cell: (row: any) => `${row.base_rate}¢`,
        sortable: true,
        sortFunction: createNumericSortFunction("base_rate"),
        width: "90px",
      },
      {
        name: (
          <span className="font-weight-bold fs-14 text-nowrap">
            Cancellation Fee
          </span>
        ),
        selector: (row: any) => row.cancel_fee,
        sortable: true,
        sortFunction: createNumericSortFunction("cancel_fee"),
        width: "148px",
        minWidth: "148px",
      },
      {
        name: <span className="font-weight-bold fs-14">Credit</span>,
        selector: (row: any) => row.credit1,
        cell: (row: any) => (
          <div className="d-flex align-items-center">
            <span>{formatCreditValue(row.credit1)}</span>
            {Number(row.credit1 || 0) > 0 && (
              <Tooltip title={buildCreditTooltip(row)}>
                <img src="/img/icon_tips.png" height={14} className="ms-1" alt="" />
              </Tooltip>
            )}
          </div>
        ),
        sortable: true,
        sortFunction: createNumericSortFunction("credit1"),
      },
      {
        name: <span className="font-weight-bold fs-14">Source</span>,
        selector: (row: any) => row.source,
        sortable: true,
        sortFunction: createStringSortFunction("source"),
      },
      {
        name: <span className="font-weight-bold fs-14"></span>,
        selector: (row: any) => {
          return (
            <div className="d-flex flex-nowrap align-items-center gap-2">
              <Button
                color="secondary"
                outline
                className="btn btn-sm"
                onClick={() =>
                  handleOpen(row.plan_id, row.price, row.created_ts, row.rank)
                }
              >
                Snapshot
              </Button>
              <Button
                onClick={() => jumpTo(row.plan_id, row.pd_id)}
                outline
                target="_blank"
                rel="noreferrer"
                className="btn btn-sm"
              >
                EFL
              </Button>
            </div>
          );
        },
        width: "190px",
      },
    ];
    return (
      <DataTable
        key={sortResetKey}
        columns={columns}
        keyField="plan_id"
        data={filterData}
        conditionalRowStyles={conditionalRowStyles}
        paginationPerPage={rowsPerPage}
        paginationRowsPerPageOptions={paginationRowsPerPageOptions}
        onChangeRowsPerPage={handleRowsPerPageChange}
        customStyles={customStyles}
        pagination
        paginationDefaultPage={tablePage}
        onChangePage={(page) => setTablePage(page)}
      />
    );
  };

  const filterSelections = () => {
    let list: React.ReactNode[] = [],
      key = 0;
    selectedTerms.forEach((term) => {
      list.push(
        <button
          key={key++}
          className={activeFilterTagClassName}
          onClick={() => {
            setSelectedTerms((prev) => prev.filter((item) => item !== term));
            resetTableSort();
          }}
        >
          {`Term: ${term} Month`}
          <i className="bx bx-x fs-15 ms-2" />
        </button>
      );
    });
    if (selectedProviderId && dataPlanList.length > 0) {
      const providerName =
        dataPlanList.find(
          (item) => String(item.provider_id) === String(selectedProviderId)
        )?.provider_name;
      if (providerName) {
      list.push(
        <button
          key={key++}
          className={activeFilterTagClassName}
          onClick={() => changeProvider("")}
        >
          {`Provider: ${providerName}`}
          <i className="bx bx-x fs-15 ms-2" />
        </button>
      );
      }
    }
    selectedSources.forEach((source) => {
      list.push(
        <button
          key={key++}
          className={activeFilterTagClassName}
          onClick={() => {
            setSelectedSources((prev) => prev.filter((item) => item !== source));
            resetTableSort();
          }}
        >
          {`Source: ${source}`}
          <i className="bx bx-x fs-15 ms-2" />
        </button>
      );
    });
    if (filterValue.plan_type) {
      const planTypeLabel =
        filterValue.plan_type === 1
          ? "Usage Bill Credit"
          : filterValue.plan_type === 3
          ? "Flat Rate"
          : filterValue.plan_type === 4
          ? "Base Fee Plans"
          : String(filterValue.plan_type);
      list.push(
        <button
          key={key++}
          className={activeFilterTagClassName}
          onClick={() => changePlanType("")}
        >
          {`Plan Type: ${planTypeLabel}`}
          <i className="bx bx-x fs-15 ms-2" />
        </button>
      );
    }
    return <ActiveFilterTags tags={list} />;
  };

  return (
    <>
      <Card
        style={{
          position: "relative",
          paddingBottom: "1rem",
          minHeight: "40rem",
        }}
      >
        <CardHeader className="align-items-center justify-content-between d-flex">
          <div>
            <h4 className="card-title mb-0 flex-grow-1">{`All Market Plans (${filterData?.length || 0})`}</h4>
            {currentLocation && currentUtility && (
              <Typography
                variant="subtitle2"
                className="text-muted"
              >{`${currentLocation.state_name} - ${currentUtility.utility_name}`}</Typography>
            )}
          </div>
          <div className="flex-shrink-0">
            {!isDownload ? (
              <Button
                color="secondary"
                onClick={exportList}
                className="btn-label"
              >
                <i className="bx bx-download label-icon align-middle fs-17 me-2"></i>
                <span>Download</span>
              </Button>
            ) : (
              <Button color="secondary" className="btn-load" outline>
                <span className="d-flex align-items-center">
                  <Spinner size="sm" className="flex-shrink-0">
                    {" "}
                    Loading...{" "}
                  </Spinner>
                  <span className="flex-grow-1 ms-2">Loading...</span>
                </span>
              </Button>
            )}
          </div>
        </CardHeader>
        <CardBody>
          {/* Row 1: kWh filter button group only */}
          <div className="mb-3">
            <UsageBtnGroup
              defaultValue={String(filterValue.price || 500)}
              onChangeValue={(val: string) => changeUsage(val)}
              isLoading={isLoading}
            />
          </div>
          {/* Row 2: left = 4 filter dropdowns, right = View My Plans + date */}
          <div className="d-flex justify-content-between align-items-center flex-wrap mb-4 gap-3">
            <div className="d-flex align-items-center gap-3 flex-wrap">
              {/* Plan Term */}
              <MultiSelectFilterDropdown
                isOpen={openSelect}
                toggle={() => setOpenSelect(!openSelect)}
                options={filterTerms}
                selected={selectedTerms}
                onChange={handleTermsChange}
                allLabel="All Terms"
                formatOption={(value) => `${value} Month`}
                width={120}
              />

              {/* Plan Type */}
              <Dropdown
                isOpen={openPlanType}
                toggle={() => setOpenPlanType(!openPlanType)}
              >
                <DropdownToggle
                  tag="button"
                  className="btn btn-light d-flex align-items-center"
                  style={{ width: 140 }}
                >
                  <span className="text-truncate" style={{ minWidth: 0 }}>
                    {filterValue.plan_type === 1
                      ? "Usage Bill Credit"
                      : filterValue.plan_type === 3
                      ? "Flat Rate"
                      : filterValue.plan_type === 4
                      ? "Base Fee Plans"
                      : "All Plan Types"}
                  </span>
                  <i className="mdi mdi-chevron-down flex-shrink-0 ms-1"></i>
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={() => changePlanType("")}>
                    All Plan Types
                  </DropdownItem>
                  <DropdownItem onClick={() => changePlanType(1)}>
                    Usage Bill Credit
                  </DropdownItem>
                  <DropdownItem onClick={() => changePlanType(3)}>
                    Flat Rate
                  </DropdownItem>
                  <DropdownItem onClick={() => changePlanType(4)}>
                    Base Fee Plans
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>

              {/* Source */}
              <MultiSelectFilterDropdown
                isOpen={openSource}
                toggle={() => setOpenSource(!openSource)}
                options={filterSources}
                selected={selectedSources}
                onChange={handleSourcesChange}
                allLabel="All Sources"
                width={170}
                className="text-uppercase"
              />

              {/* Provider Name */}
              <Dropdown
                isOpen={openProvider}
                toggle={() => setOpenProvider(!openProvider)}
              >
                <DropdownToggle
                  tag="button"
                  className="btn btn-light d-flex align-items-center"
                  style={{ width: 150 }}
                >
                  <span className="text-truncate" style={{ minWidth: 0 }}>
                    {selectedProviderId
                      ? filterProviders.find(
                          (p: any) =>
                            String(p.provider_id) === String(selectedProviderId)
                        )?.provider_name || "All Provider"
                      : "All Provider"}
                  </span>
                  <i className="mdi mdi-chevron-down flex-shrink-0 ms-1"></i>
                </DropdownToggle>
                <DropdownMenu
                  style={{ overflowY: "auto", maxHeight: "20rem" }}
                >
                  <DropdownItem onClick={() => changeProvider("")}>
                    All Provider
                  </DropdownItem>
                  {filterProviders.map((item: any) => (
                    <DropdownItem
                      key={item.provider_id}
                      onClick={() =>
                        changeProvider(String(item.provider_id))
                      }
                    >
                      {item.provider_name}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </div>
            <div className="d-flex align-items-center gap-3 flex-wrap">
              {/* View My Plans */}
              <div className="form-check form-switch form-switch-md d-flex align-items-center form-switch-secondary">
                <Label className="text-muted d-flex align-items-center justify-content-between mb-0">
                  <Input
                    className="code-switch"
                    type="checkbox"
                    value=""
                    checked={checked}
                    onChange={(e) => {
                      showMeOnly(e.target.checked);
                    }}
                  />
                  View My Plans
                </Label>
              </div>
              {/* Date */}
              <Flatpickr
                className="rank_datepicker"
                value={value}
                options={{
                  dateFormat: "Y-m-d",
                  defaultDate: [today],
                  minDate: moment().startOf("year").format("YYYY-MM-DD"),
                  maxDate: today,
                  allowInput: true,
                }}
                style={{ width: 110 }}
                onChange={([newValue]: any) => {
                  setValue(moment(newValue).format("YYYY-MM-DD"));
                  changeDate(newValue);
                }}
              />
            </div>
          </div>
          <div className="mb-3 w-100">{filterSelections()}</div>
          {isLoading ? (
            <Loader />
          ) : (
            <div className="rdt_out">
              {dataPlanList?.length > 0 ? renderTopPlanTable() : <NoResult />}
            </div>
          )}
        </CardBody>
      </Card>
      <Modal size="lg" isOpen={open} toggle={handleClose} centered>
        <ModalHeader toggle={handleClose}>Plan Detail</ModalHeader>
        {/* <AiSummary data={dataString} /> */}
        <div className="modal-body">
          {isShow ? (
            <Loader />
          ) : (
            <React.Fragment>
              <Table className="align-middle table-fixed mb-0">
                <thead>
                  <tr>
                    <th scope="col">Rank</th>
                    <th scope="col">REP Name</th>
                    <th scope="col">TDU Name</th>
                    <th scope="col">Term</th>
                    <th scope="col">Base Rate</th>
                    <th scope="col">Plan Source</th>
                    <th scope="col">Cancellation Fee</th>
                    <th scope="col">Credit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">{planDetail.rank}</th>
                    <td>
                      <button
                        type="button"
                        className="btn btn-link p-0"
                        onClick={handleJumpToPlanInsight}
                      >
                        {planDetail.plan.provider_name}
                      </button>
                    </td>
                    <td>{planDetail.plan.utility_name}</td>
                    <td>{planDetail.plan.contract_term}</td>
                    <td>
                      {planDetail.plan.base_rate}
                      {planDetail.plan.base_rate ? "¢" : ""}
                    </td>
                    <td>{planDetail.plan.source || ""}</td>
                    <td>{planDetail.plan.cancel_fee}</td>
                    <td>
                      <div className="d-flex align-items-center">
                        <span>{formatCreditValue(planDetail.plan.credit1)}</span>
                        {Number(planDetail.plan.credit1 || 0) > 0 && (
                          <Tooltip title={buildCreditTooltip(planDetail.plan)}>
                            <img
                              src="/img/icon_tips.png"
                              height={14}
                              className="ms-1"
                              alt=""
                            />
                          </Tooltip>
                        )}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
              {hasRankTrend ? (
                <RankChart
                  title="Rank Trend"
                  data={detailData}
                  isLoading={isLoading}
                />
              ) : (
                <NoResult />
              )}

              <KWHPriceChart
                plan_id={planDetail.plan.plan_id}
                pd_id={planDetail.plan.pd_id}
              />
            </React.Fragment>
          )}
        </div>
      </Modal>
    </>
  );
};
export default LoginTopPlan;
